module.exports = __webpack_public_path__ + "img/PWstudio-TryOut.07cc40bd.png";